import { Component, computed, EventEmitter, inject, Output } from '@angular/core';
import { DataService } from 'src/data-store/data.service';
import {
  AccountRoute,
  DashboardRoute,
  MoneyAndTransactionsRoute,
  InvestmentsListRoute,
  BlogRoute,
  CollaboratorRoute, FaqRoute, UserNotificationsRoute, UnauthRoutes,
  ProductLandingRoute
} from 'src/models/routes.model';

interface HamburgerLink {
  name: string;
  route: string;
  fragment?: string;
  desktopView: boolean;
  badgeValue?: number;
  development?: boolean;
  submenu?: HamburgerLink[];
  hidden?: boolean;
}
@Component({
  selector: 'liberro-basic-layout-hamburger-menu',
  standalone: false,
  templateUrl: './basic-layout-hamburger-menu.component.html',
  styleUrl: './basic-layout-hamburger-menu.component.less'
})
export class BasicLayoutHamburgerMenuComponent {

  private dataService = inject(DataService);

  @Output() public logoutBtnClick = new EventEmitter<void>();
  @Output() public menuItemClick = new EventEmitter<void>();

  public hamburgerLinks = computed<HamburgerLink[]>(() => {
    const unreadItemsSumCount = this.dataService.unreadItemsSumCount();
    return [
      {
        name: 'header.links.mainPage',
        route: `/${DashboardRoute.DASHBOARD}`,
        desktopView: false
      },
      {
        name: 'header.links.myInvestments',
        route: `/${InvestmentsListRoute.INVESTMENTS}`,
        desktopView: false
      },
      {
        name: 'header.links.products',
        route: '',
        desktopView: false,
        submenu: [
/*           {
            name: 'header.products.portfolio.title',
            route: '',
            desktopView: false
          }, */
          {
            name: 'header.products.thematicStrategy.title',
            route: `/${ProductLandingRoute.PRODUCT}/${ProductLandingRoute.THEMATIC_STRATEGY}`,
            desktopView: false
          },
          {
            name: 'header.products.customStrategy.title',
            route: `/${ProductLandingRoute.PRODUCT}/${ProductLandingRoute.CUSTOM_STRATEGY}`,
            desktopView: false
          },
/*           {
            name: 'header.products.dip.title',
            route: '',
            desktopView: false
          }, */
        ]
      },
      {
        name: 'header.links.posts',
        route: `/${BlogRoute.BLOG}`,
        desktopView: false
      },
      // {
      //   name: 'header.links.aboutUs',
      //   route: '',
      //   desktopView: false,
      // },
      {
        name: 'header.links.myConsultant',
        route: `/${CollaboratorRoute.COLLABORATOR}`,
        desktopView: false
      },
      {
        name: 'header.hamburgerLinks.myAccount',
        route: `/${AccountRoute.ACCOUNT}`,
        desktopView: true
      },
      {
        name: 'header.hamburgerLinks.moneyAndTransactions',
        route: `/${MoneyAndTransactionsRoute.MONEY_TRANSACTIONS}`,
        desktopView: true
      },
      {
        name: 'header.hamburgerLinks.needAdvice',
        route: `/${FaqRoute.FAQ}`,
        desktopView: true
      },
      {
        name: 'header.hamburgerLinks.messagesAndNotifications',
        route: `/${UserNotificationsRoute.USER_NOTIFICATIONS}`,
        desktopView: true,
        badgeValue: unreadItemsSumCount
      },
      // TODO: https://gitlab.com/dfcz/bwm-frontend/-/issues/47
      /*{
        name: 'header.hamburgerLinks.devComponents',
        route: '/components',
        desktopView: true,
        development: true,
      },*/
    ];
  });

  public logout(): void {
    this.logoutBtnClick.emit();
  }

  public onMenuItemClick(): void {
    this.menuItemClick.emit();
  }

}
